"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const pit_operation_types_1 = require("./pit-operation.types");
const app_types_1 = require("pages/app.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataContractor: [],
    dataArea: [],
    dataBrand: [],
    dataExcavator: [],
    dataPit: [],
    dataSeam: [],
    dataDumpTruck: [],
    dataCheckpoint: [],
    mutationMode: false,
    filterChild: '',
    messageSuccess: 'Data Saved Successfully',
    dataItem: {
        id: '0',
        contractor_id: '',
        contractor_name: '',
        checkpoint_id: '',
        checkpoint_name: '',
        checkpoint: {
            checkpoint_id: '',
            checkpoint_name: '',
        },
        area_id: '',
        area: {
            id: '',
            area_name: '',
        },
        area_name: '',
        brand_id: '',
        brand: {
            id: '',
            name: '',
        },
        brand_name: '',
        excavator_id: '',
        excavator: {
            id: '',
            excavator_no: '',
        },
        excavator_no: '',
        pit_id: '',
        pit: {
            id: '',
            pit: '',
        },
        pit_name: '',
        contractor: {
            id: '',
            contractor_name: '',
        },
        seam: {
            id: '',
            seam: '',
        },
        seam_id: '',
        seam_name: '',
        dump_truck: [],
        dumpTruck_name: '',
        is_active: {
            value: true,
            status: 'Active',
        },
        modified_by: '',
        created_date: new Date(),
        modified_date: new Date(),
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }],
    },
};
const pitOperationReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [pit_operation_types_1.pitOperationTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [pit_operation_types_1.pitOperationTypes.ON_EXPAND_GRID]: (state, action) => {
        const { dataGrid } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid });
    },
    [pit_operation_types_1.pitOperationTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [pit_operation_types_1.pitOperationTypes.GET_DETAIL]: (state, action) => {
        const { dataContractor, dataBrand, dataPit } = action.payload;
        return Object.assign(Object.assign({}, state), { dataContractor,
            dataBrand,
            dataPit });
    },
    [pit_operation_types_1.pitOperationTypes.GET_DUMPTRUCK]: (state, action) => {
        const { dataDumpTruck, dataItem } = action.payload;
        return Object.assign(Object.assign({}, state), { dataDumpTruck,
            dataItem });
    },
    [pit_operation_types_1.pitOperationTypes.RESET_DUMPTRUCK]: (state, action) => {
        const { dataDumpTruck } = action.payload;
        return Object.assign(Object.assign({}, state), { dataDumpTruck });
    },
    [pit_operation_types_1.pitOperationTypes.GET_EXCAVATOR]: (state, action) => {
        const { dataExcavator } = action.payload;
        return Object.assign(Object.assign({}, state), { dataExcavator });
    },
    [pit_operation_types_1.pitOperationTypes.GET_AREA]: (state, action) => {
        const { dataArea } = action.payload;
        return Object.assign(Object.assign({}, state), { dataArea });
    },
    [pit_operation_types_1.pitOperationTypes.GET_SEAM]: (state, action) => {
        const { dataSeam } = action.payload;
        return Object.assign(Object.assign({}, state), { dataSeam });
    },
    [pit_operation_types_1.pitOperationTypes.GET_CHECKPOINT]: (state, action) => {
        const { dataCheckpoint } = action.payload;
        const checkpoint_data = dataCheckpoint.find((item) => item.checkpoint_name === state.dataItem.checkpoint_name) || {
            checkpoint_id: '',
            checkpoint_name: '',
        };
        return Object.assign(Object.assign({}, state), { dataItem: Object.assign(Object.assign({}, state.dataItem), { checkpoint: {
                    checkpoint_id: checkpoint_data.checkpoint_id,
                    checkpoint_name: checkpoint_data.checkpoint_name,
                } }), dataCheckpoint });
    },
    [pit_operation_types_1.pitOperationTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isLoading: false, isSuccess: false });
    },
    [pit_operation_types_1.pitOperationTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess, isLoading } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess, isLoading: isLoading ? isLoading : initialState.isLoading });
    },
    [pit_operation_types_1.pitOperationTypes.ON_FILTER_CHILD]: (state, action) => {
        const { filterChild } = action.payload;
        return Object.assign(Object.assign({}, state), { filterChild, dataStates: initialState.dataStates, isLoading: true });
    },
    [pit_operation_types_1.pitOperationTypes.ON_DELETE]: (state) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, mutationMode: false });
    },
    [pit_operation_types_1.pitOperationTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, isLoading: true, mutationMode: false, dataItem: initialState.dataItem, messageSuccess: initialState.messageSuccess, dataGrid: state.dataGrid.map((item) => {
                if (item.id === dataItem.id)
                    return dataItem;
                return item;
            }) });
    },
    [pit_operation_types_1.pitOperationTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, filterChild: '', dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [pit_operation_types_1.pitOperationTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { sort: action.payload }) });
    },
    [pit_operation_types_1.pitOperationTypes.ON_DELETE_ALL_PIT_OPERATION]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataGrid: [], isLoading: true, isSuccess: true, mutationMode: false, dataStates: initialState.dataStates, messageSuccess: action.payload.errorMessage });
    },
});
exports.default = pitOperationReducer;
